import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { IMG_URL } from "../App";

function Carousel({ list }) {
  let [currItem, setCurrItem] = useState({});
  let [currIndex, setCurrIndex] = useState(0);
  useEffect(() => {
    setCurrItem(list[0]);
    if (list.length <= 1) {
      document.getElementsByClassName("carousel__btn")[0].disabled = true;
      document.getElementsByClassName("carousel__btn")[1].disabled = true;
      document.getElementsByClassName("carousel__buttons")[0].style.opacity = 0;
    }
  }, []);

  const handleBackBtn = () => {
    if (currIndex > 0) {
      setCurrItem(list[currIndex - 1]);
      setCurrIndex((prevIndex) => prevIndex - 1);
    } else {
      setCurrItem(list[list.length - 1]);
      setCurrIndex(list.length - 1);
    }
  };
  const handleNextBtn = () => {
    if (currIndex < list.length - 1) {
      setCurrItem(list[currIndex + 1]);
      setCurrIndex((prevIndex) => prevIndex + 1);
    } else {
      setCurrItem(list[0]);
      setCurrIndex(0);
    }
  };

  return (
    <div className="carousel">
      {currItem.contents &&
      currItem.contents[0] &&
      currItem.contents[0].publicationType !== "video" ? (
        <img
          src={`${IMG_URL}/content/${currItem.contents[0]?.path}`}
          alt="postImage"
          className="carousel__image"
        />
      ) : currItem.contents && !currItem.contents[0] ? (
        <img src="/no-image.jfif" alt="noPostImage" />
      ) : (
        <></>
      )}
      <div className="carousel__content">
        <div className="carousel__buttons">
          <button onClick={handleBackBtn} className="carousel__btn">
            <img src="/expand_less.png" alt="" />
          </button>
          <button onClick={handleNextBtn} className="carousel__btn">
            <img src="/expand_more.png" alt="" />
          </button>
        </div>
        <div className="carousel__downSide">
          <h2 className="carousel__title">{currItem.title}</h2>
          <Link
            to={`/publicaciones/${currItem.title
              ?.replaceAll("/", "-")
              .split(" ")
              .join("-")
              .toLowerCase()}/${currItem.id}`}
            className="carousel__viewMoreBtn"
          >
            Leer más
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Carousel;
